// src/routes/PrivateRoute.jsx

import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { paths } from './helpers';

const PrivateRoute = () => {
  const { token } = useSelector((state) => state.auth);

  if (!token) {
    return <Navigate to={paths.public.login()} replace />;
  }

  return <Outlet />;
};

export default PrivateRoute;
